import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Eye, EyeOff } from 'lucide-react';
import { Card } from '../ui/card';

export function formatApiError(detail, fallback = 'କିଛି ଭୁଲ ହେଲା। ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।') {
  if (detail == null) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
  if (typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export function AuthCard({ title, subtitle, children, back = '/profile' }) {
  return (
    <div className="px-4 pt-4 pb-6">
      <Link to={back} className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-800" data-testid="auth-back-link">
        <ArrowLeft size={16} /> ପଛକୁ
      </Link>
      <div className="mt-4 mb-5">
        <div className="text-xs font-bold tracking-widest uppercase text-emerald-700">Gurusevakendra</div>
        <h1 className="text-2xl font-extrabold text-gray-900 mt-1">{title}</h1>
        {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
      </div>
      <Card className="rounded-3xl p-5 border-gray-200 shadow-sm">{children}</Card>
    </div>
  );
}

export function Field({ label, type = 'text', testId, ...props }) {
  const [show, setShow] = useState(false);
  const isPw = type === 'password';
  return (
    <label className="block">
      <span className="text-xs font-bold text-gray-700">{label}</span>
      <div className="relative mt-1">
        <input
          type={isPw && show ? 'text' : type}
          data-testid={testId}
          className="w-full h-12 rounded-xl border border-gray-300 px-4 pr-11 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
          {...props}
        />
        {isPw && (
          <button type="button" onClick={() => setShow(s => !s)} aria-label="toggle password"
            data-testid={`${testId}-toggle`}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700">
            {show ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        )}
      </div>
    </label>
  );
}

export function ErrorBox({ message, testId = 'auth-error' }) {
  if (!message) return null;
  return <div data-testid={testId} className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-3 py-2">{message}</div>;
}

export function GoogleButton({ onClick }) {
  return (
    <button type="button" onClick={onClick} data-testid="google-login-button"
      className="w-full h-12 rounded-xl border border-gray-300 bg-white hover:bg-gray-50 font-bold text-sm text-gray-800 flex items-center justify-center gap-2 transition-colors">
      <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.6 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.3l7.8 6.1C12.3 13.6 17.7 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-2.8-.4-4H24v8.1h12.8c-.3 2.2-1.7 5.4-4.9 7.6l7.5 5.8c4.5-4.2 7.1-10.3 7.1-17.5z"/><path fill="#FBBC05" d="M10.4 28.6A14.6 14.6 0 0 1 9.5 24c0-1.6.3-3.2.8-4.6l-7.8-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.7l7.8-6.1z"/><path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.5-5.8c-2 1.4-4.7 2.4-8.4 2.4-6.3 0-11.7-4.1-13.6-9.9l-7.8 6.1C6.5 42.6 14.6 48 24 48z"/></svg>
      Google ସହ ଲଗଇନ କରନ୍ତୁ
    </button>
  );
}

export function Divider() {
  return (
    <div className="flex items-center gap-3 my-4">
      <div className="h-px flex-1 bg-gray-200" /><span className="text-[11px] font-bold text-gray-400">କିମ୍ବା / OR</span><div className="h-px flex-1 bg-gray-200" />
    </div>
  );
}
